const ISO_DATE_PREFIX = /^(\d{4})-(\d{2})-(\d{2})/;

export const toDate = (value) => {
  if (!value) return null;

  let candidate;
  if (value instanceof Date) {
    candidate = new Date(value);
  } else if (typeof value === "string") {
    const isoDate = value.match(ISO_DATE_PREFIX);
    if (isoDate) {
      const [, year, month, day] = isoDate.map(Number);
      candidate = new Date(year, month - 1, day);
      if (
        candidate.getFullYear() !== year ||
        candidate.getMonth() !== month - 1 ||
        candidate.getDate() !== day
      ) {
        return null;
      }
    } else {
      candidate = new Date(value);
    }
  } else {
    candidate = new Date(value);
  }

  if (Number.isNaN(candidate.getTime())) return null;
  candidate.setHours(0, 0, 0, 0);
  return candidate;
};
